import { Skeleton } from '@mui/material';

export const AddressCardPlaceholder = () => {
  return <Skeleton variant='rectangular' width='100%' height={250} />;
};
